import ApiService from './api.service'

const BoxService = {
  storeBox: async function(data) {
    try {
      const response = await ApiService.post('/cajas/agencia', data)
      return response
    } catch (error) {
      throw error
    }
  },

  updateBox: async function(id, data) {
    try {
      const response = await ApiService.put(`/cajas/${id}`, data)
      return response
    } catch (error) {
      throw error
    }
  },

  deleteBox: async function(data) {
    try {
      const response = await ApiService.deleteParams('/cajas', {data: {cajas: data}})
      return response
    } catch (error) {
      throw error
    }
  },

  downloadCubi: async function(id) {
    try {
      const options = {
        method: 'get',
        url: `/cajas/cubi/${id}`,
        responseType: 'arraybuffer'
      }
      const response = await ApiService.customRequest(options)
      return response
    } catch (error) {
      throw error
    }
  },

  pdfListBox: async function(data) {
    try {
      const options = {
        method: 'post',
        url: '/cajas/list-pdf',
        data: data,
        responseType: 'arraybuffer'
      }
      const response = await ApiService.customRequest(options)
      return response
    } catch (error) {
      throw error
    }
  },

  excelListBox: async function(data) {
    try {
      const options = {
        method: 'post',
        url: '/cajas/list-excel',
        data: data,
        responseType: 'arraybuffer'
      }
      const response = await ApiService.customRequest(options)
      return response
    } catch (error) {
      throw error
    }
  },

  showFoldersBox: async function(url) {
    try {
      const response = await ApiService.get(url)
      return response
    } catch (error) {
      throw error
    }
  },

  uploadFolder: async function(data) {
    try {
      const response = await ApiService.post('/carpetas/importar', data)
      return response
    } catch (error) {
      throw error
    }
  },

  storeFolder: async function(data) {
    try {
      const response = await ApiService.post('/carpetas', data)
      return response
    } catch (error) {
      throw error
    }
  },

  updateFolder: async function(id, data) {
    try {
      const response = await ApiService.put(`/carpetas/${id}`, data)
      return response
    } catch (error) {
      throw error
    }
  },

  showFolder: async function(url) {
    try {
      const response = await ApiService.get(url)
      return response
    } catch (error) {
      throw error
    }
  },

  deleteFolder: async function(id) {
    try {
      const response = await ApiService.delete(`/carpetas/${id}`)
      return response
    } catch (error) {
      throw error
    }
  },

  getFilesByFolderId: async function(url) {
    try {
      const response = await ApiService.get(url)
      return response
    } catch (error) {
      throw error
    }
  },

  deleteFileById: async function(data) {
    try {
      const response = await ApiService.post('/files/delete', data)
      return response
    } catch (error) {
      throw error
    }
  },
  
  updateFileById: async function(data) {
    try {
      const response = await ApiService.post('/files/update', data)
      return response
    } catch (error) {
      throw error
    }
  },

  saveFileDescription: async function(data) {
    try {
      const response = await ApiService.post('/files/description', data)
      return response
    } catch (error) {
      throw error
    }
  },

  getDigitalFolders: async function(url) {
    try {
      const response = await ApiService.get(url)
      return response
    } catch (error) {
      throw error
    }
  },

  getFileFolder: async function(url) {
    try {
      const response = await ApiService.get(url)
      return response
    } catch (error) {
      throw error
    }
  },

  downloadDigital1Zip: async function(folder_id, dui, year, aduana, agencia) {
    try {
      const options = {
        method: 'get',
        url: `files/download/z1?folder_id=${folder_id}&dui=${dui}&year=${year}&aduana=${aduana}&agencia=${agencia}`,
        responseType: 'blob'
      }
      const response = await ApiService.customRequest(options)
      return response
    } catch (error) {
      throw error
    }
  },

  downloadDigital2Zip: async function(folder_id, dui, year, aduana, agencia) {
    try {
      const options = {
        method: 'get',
        url: `files/download/z2?folder_id=${folder_id}&dui=${dui}&year=${year}&aduana=${aduana}&agencia=${agencia}`,
        responseType: 'blob'
      }
      const response = await ApiService.customRequest(options)
      return response
    } catch (error) {
      throw error
    }
  },

  pdfListFolders: async function(id) {
    try {
      const options = {
        method: 'get',
        url: `/cajas/carpetas/${id}/list-pdf`,
        responseType: 'arraybuffer'
      }
      const response = await ApiService.customRequest(options)
      return response
    } catch (error) {
      throw error
    }
  },

  excelListFolders: async function(id) {
    try {
      const options = {
        method: 'get',
        url: `/cajas/carpetas/${id}/list-excel`,
        responseType: 'arraybuffer'
      }
      const response = await ApiService.customRequest(options)
      return response
    } catch (error) {
      throw error
    }
  },
}

export default BoxService